import { jsxs as g, jsx as i } from "react/jsx-runtime";
import y from "react";
import e, { css as l } from "styled-components";
import { RangoImage as C } from "./Image.js";
import { R, H as z } from "../chunks/Heading.2a0f9b41.js";
import { R as b, P as H } from "../chunks/Paragraph.60dac1f9.js";
import { RangoButtonMini as N } from "./ButtonMini.js";
const B = e.div.withConfig({
  displayName: "TopicImage",
  componentId: "sc-cb9u7x-0"
})(["display:flex;", " ", ""], (r) => r.orientation === n.Vertical && l(["flex-direction:column;align-items:center;& ", "{width:fit-content;display:inline-flex;padding-bottom:var(--spacing-3x);& ", "{height:var(--size-15x);border-radius:var(--border-radius-circular);}}", "{text-align:center;}", "{text-align:center;}", "{text-align:center;}"], d, c, p, o, s), (r) => r.orientation === n.Horizontal && l(["flex-direction:row;", "{text-align:left;}& ", "{padding-right:var(--spacing-3x);& ", "{height:auto;width:var(--size-10x);border-radius:var(--border-radius-circular);}}"], o, d, c)), p = e(R).withConfig({
  displayName: "Heading",
  componentId: "sc-cb9u7x-1"
})(["padding-bottom:var(--spacing-2x);"]), o = e(b).withConfig({
  displayName: "Paragraph",
  componentId: "sc-cb9u7x-2"
})([""]), s = e.div.withConfig({
  displayName: "ButtonWrapper",
  componentId: "sc-cb9u7x-3"
})(["padding-top:var(--spacing-1x);"]), c = e(C).withConfig({
  displayName: "Image",
  componentId: "sc-cb9u7x-4"
})([""]), d = e.div.withConfig({
  displayName: "ImageWrapper",
  componentId: "sc-cb9u7x-5"
})([""]), n = {
  Horizontal: "horizontal",
  Vertical: "vertical"
};
Object.values(n);
const T = y.forwardRef(({
  imageProps: r,
  orientation: m = n.Vertical,
  headingProps: t,
  paragraph: h = "",
  buttonMiniProps: a,
  ...f
}, u) => {
  const x = () => t ? /* @__PURE__ */ i(p, { ...t, size: z.SM, children: t.children }) : null, I = (w) => {
    a && a.onClick && a.onClick(w);
  }, v = () => a ? /* @__PURE__ */ i(s, { children: /* @__PURE__ */ i(N, { ...a, onClick: I, children: a.children }) }) : null;
  return /* @__PURE__ */ g(B, { orientation: m, ...f, ref: u, "data-testid": "rango-topic-image", "data-rango-component": "rango-topic-image", "data-is-rango": !0, children: [
    /* @__PURE__ */ i(d, { children: /* @__PURE__ */ i(c, { ...r }) }),
    /* @__PURE__ */ g("div", { children: [
      x(),
      /* @__PURE__ */ i(o, { size: H.SM, children: h }),
      v()
    ] })
  ] });
});
T.displayName = "RangoTopicImage";
export {
  T as RangoTopicImage,
  n as TopicImageOrientation
};
